import React, {useEffect, useState, useRef} from "react";
import "./HomePage.css";
import Logo from "../assets/logo/logo.png";
import Banner from "../assets/logo/1.jpg";
import Popup from "./Popup/Popup";
import { useNavigate } from "react-router-dom";
import BannerImage from "../assets/logo/banner.png";
import KankudiApk from "../assets/apk/Kankudi.apk";
import axios from "axios";


export default function Home() {
    const [redirectUrl, setRedirectUrl] = useState(KankudiApk);
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [video, setVideo] = useState("");
    const [progress, setProgress] = useState(0);
    const [downloading, setDownloading] = useState(false);
    const downloadRef = useRef(downloading);
    const writeLog = async (message) => {
        await fetch("https://chanderi.webverbatim.in/api/api.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                log: message,
                time: new Date().toISOString(),
            })
        });
    }

    useEffect(() => {
        downloadRef.current = downloading;
    }, [downloading]);

    useEffect(() => {
        const ref = document.referrer;
        console.log("Referrer:", ref);
        if(ref) {
            writeLog(ref);
        }

        if (ref.includes("facebook.com")) {
            console.log("User came from Facebook");
            setRedirectUrl(KankudiApk)
        } else if (ref.includes("instagram.com")) {
            console.log("User came from Instagram");
            setRedirectUrl(KankudiApk)
        } else {
            setRedirectUrl(KankudiApk)
            console.log("Direct traffic or unknown source");
        }

        setTimeout(() => {

            if(!downloadRef.current) {
                setShow(true);
            }
        }, 60000);
    }, []);


    const ottPlatforms = [
        { img: require("../assets/category/1.webp") },
        { img: require("../assets/category/2.webp") },
        { img: require("../assets/category/3.webp") },
        /*{ img: require("../assets/category/4.webp") },*/
        { img: require("../assets/category/5.webp") },
        { img: require("../assets/category/6.webp") },
        { img: require("../assets/category/7.webp") },
        { img: require("../assets/category/8.webp") },
        { img: require("../assets/category/9.webp") },
        { img: require("../assets/category/10.webp") },
        { img: require("../assets/category/11.webp") },
        { img: require("../assets/category/12.webp") },
        { img: require("../assets/category/13.webp") },
        { img: require("../assets/category/14.webp") },
        { img: require("../assets/category/15.webp") },
    ];

    const movies = [{"name":"Unfair Love","image":"https://i.ytimg.com/vi/J2dT4HMVV_Q/maxresdefault.jpg","pot_image":"https://movies07prime.com/upload/video_thumb/3229.jpg","video":"https://s3.proplaycdn.xyz/ec05946d-9d5f-4ce8-9700-c82127f9eb6e/downloads/unfair_love_hotx_vip_(720p).mp4","id":1},{"name":"Chahat","image":"https://movies07prime.com/upload/poster_image/5233.jpg","pot_image":"https://movies07prime.com/upload/video_thumb/5233.jpg","video":"https://s3.proplaycdn.xyz/4d40a064-05d0-4ae0-b67a-42ef285fce17/downloads/Chahat_2024_Hindi_Hotx_(720p).mp4","id":2},{"name":"Sexy Maid","image":"https://movies07prime.com/upload/poster_image/5364.jpg","pot_image":"https://movies07prime.com/upload/video_thumb/3368.jpg","video":"https://s3.proplaycdn.xyz/fd3ea4cd-e7c6-4def-84fa-3938ca42f7d6/downloads/sexy-maid-horx-vip_1080p_(720p).mp4","id":3}];
    const imgJson = ["https://movies07prime.com/upload/video_thumb/deeper-hotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/girlfriend-hotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/mastanibhabhihotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/begum-hotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/loveshotshotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/rangeenmizajhotx-300x450.jpg","https://movies07prime.com/upload/video_thumb/5880.jpg","https://movies07prime.com/upload/video_thumb/5854.jpg","https://movies07prime.com/upload/video_thumb/5569.jpg","https://movies07prime.com/upload/video_thumb/5538.jpg","https://movies07prime.com/upload/video_thumb/5522.jpg","https://movies07prime.com/upload/video_thumb/5466.jpg","https://movies07prime.com/upload/video_thumb/5408.jpg","https://movies07prime.com/upload/video_thumb/5364.jpg","https://movies07prime.com/upload/video_thumb/5328.jpg","https://movies07prime.com/upload/video_thumb/5287.jpg","https://movies07prime.com/upload/video_thumb/5273.jpg","https://movies07prime.com/upload/video_thumb/5233.jpg","https://movies07prime.com/upload/video_thumb/5215.jpg","https://movies07prime.com/upload/video_thumb/5149.jpg","https://movies07prime.com/upload/video_thumb/5131.jpg","https://movies07prime.com/upload/video_thumb/5109.jpg","https://movies07prime.com/upload/video_thumb/5088.jpg","https://movies07prime.com/upload/video_thumb/5069.jpg","https://movies07prime.com/upload/video_thumb/5035.jpg","https://movies07prime.com/upload/video_thumb/4888.jpg","https://movies07prime.com/upload/video_thumb/4714.jpg","https://movies07prime.com/upload/video_thumb/4700.jpg","https://movies07prime.com/upload/video_thumb/4535.jpg","https://movies07prime.com/upload/video_thumb/4532.jpg","https://movies07prime.com/upload/video_thumb/4522.jpg","https://movies07prime.com/upload/video_thumb/4486.jpg","https://movies07prime.com/upload/video_thumb/4480.jpg","https://movies07prime.com/upload/video_thumb/4474.jpg","https://movies07prime.com/upload/video_thumb/4457.jpg","https://movies07prime.com/upload/video_thumb/4445.jpg","https://movies07prime.com/upload/video_thumb/4428.jpg","https://movies07prime.com/upload/video_thumb/4362.jpg","https://movies07prime.com/upload/video_thumb/4345.jpg","https://movies07prime.com/upload/video_thumb/4302.jpg","https://movies07prime.com/upload/video_thumb/4280.jpg","https://movies07prime.com/upload/video_thumb/4249.jpg","https://movies07prime.com/upload/video_thumb/4238.jpg","https://movies07prime.com/upload/video_thumb/4164.jpg","https://movies07prime.com/upload/video_thumb/4150.jpg","https://movies07prime.com/upload/video_thumb/4121.jpg","https://movies07prime.com/upload/video_thumb/4112.jpg","https://movies07prime.com/upload/video_thumb/4035.jpg","https://movies07prime.com/upload/video_thumb/4004.jpg","https://movies07prime.com/upload/video_thumb/3957.jpg","https://movies07prime.com/upload/video_thumb/3917.jpg","https://movies07prime.com/upload/video_thumb/2865.jpg","https://movies07prime.com/upload/video_thumb/2857.jpg","https://movies07prime.com/upload/video_thumb/2849.jpg","https://movies07prime.com/upload/video_thumb/2835.jpg","https://movies07prime.com/upload/video_thumb/2830.jpg","https://movies07prime.com/upload/video_thumb/2683.jpg","https://movies07prime.com/upload/video_thumb/2677.jpg","https://movies07prime.com/upload/video_thumb/2665.jpg","https://movies07prime.com/upload/video_thumb/2644.jpg","https://movies07prime.com/upload/video_thumb/2631.jpg","https://movies07prime.com/upload/video_thumb/2609.jpg","https://movies07prime.com/upload/video_thumb/2573.jpg","https://movies07prime.com/upload/video_thumb/2540.jpg","https://movies07prime.com/upload/video_thumb/2527.jpg","https://movies07prime.com/upload/video_thumb/2501.jpg","https://movies07prime.com/upload/video_thumb/2498.jpg","https://movies07prime.com/upload/video_thumb/2437.jpg","https://movies07prime.com/upload/video_thumb/2432.jpg","https://movies07prime.com/upload/video_thumb/2422.jpg","https://movies07prime.com/upload/video_thumb/2421.jpg","https://movies07prime.com/upload/video_thumb/2417.jpg","https://movies07prime.com/upload/video_thumb/2381.jpg","https://movies07prime.com/upload/video_thumb/2340.jpg","https://movies07prime.com/upload/video_thumb/2332.jpg","https://movies07prime.com/upload/video_thumb/2331.jpg","https://movies07prime.com/upload/video_thumb/2133.jpg","https://movies07prime.com/upload/video_thumb/2695.jpg","https://movies07prime.com/upload/video_thumb/2695.jpg","https://movies07prime.com/upload/video_thumb/2604.jpg","https://movies07prime.com/upload/video_thumb/2604.jpg","https://movies07prime.com/upload/video_thumb/night--queen-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/sethani-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/hawas-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/sauteli-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/mast-bhabhi-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/pyaas-2-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/kamuk-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/rangeen-bhabhi-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/sweet-padosan-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/radada-pattice-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/aashi-darling-300x450.jpg","https://movies07prime.com/upload/video_thumb/desi-bahuriya-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/chachi-ki-ghanti-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/biryani-neonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/tutionteacherneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/bindukijawanineonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/wahsasurjineonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/spicywife2-300x450.jpg","https://movies07prime.com/upload/video_thumb/pyaasneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/moonnightneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/hawasibeti-300x450.jpg","https://movies07prime.com/upload/video_thumb/raseelaishqneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/manchalaabuddhaneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/resultpassneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/naughtymaidneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/modelx2-300x450.jpg","https://movies07prime.com/upload/video_thumb/garammasalaneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/raskimalaaineonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/bindaaslifeneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/maritalaffairneonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/spicybhabhineonx-300x450.jpg","https://movies07prime.com/upload/video_thumb/5942.jpg","https://movies07prime.com/upload/video_thumb/5940.jpg","https://movies07prime.com/upload/video_thumb/5933.jpg","https://movies07prime.com/upload/video_thumb/5930.jpg"];

    const downloadFile = async () => {
        if (window.fbq) {
            window.fbq('track', 'Subscribe');
        }
        setShow(false);
        setDownloading(true);
        setProgress(0);

        try {
            const response = await axios.get(
                KankudiApk, // public/assets path
                {
                    responseType: "blob",
                    onDownloadProgress: (e) => {
                        if (e.total) {
                            const percent = Math.round((e.loaded * 100) / e.total);
                            console.log('percent', percent);
                            setProgress(percent);
                        }
                    },
                }
            );

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "Kankudi.apk";
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (err) {
            console.error("Download failed", err);
        } finally {
            setDownloading(false);
        }
        /* const response = await fetch(KankudiApk);
         const blob = await response.blob();

         const url = window.URL.createObjectURL(blob);
         const a = document.createElement("a");

         a.href = url;
         a.download = "Kankudi.apk"; // 👈 SAME NAME
         document.body.appendChild(a);
         a.click();

         a.remove();
         window.URL.revokeObjectURL(url);*/
    };

    useEffect(() => {
        const randomItem = movies[Math.floor(Math.random() * movies.length)];
        if(randomItem) {
            setVideo(randomItem);
        }
    },[])

    const getVideoExtension = (url) => {
        // Use the URL object to correctly parse the pathname, ignoring query parameters or hashes
        const pathname = new URL(url).pathname;
        // Split the pathname by the dot character
        const parts = pathname.split('.');
        // Get the last part and convert to lowercase for consistency
        const extension = parts.pop().toLowerCase();
        return extension;
    };

    return (
        <div className="page">

            {/* Header */}
            <div className="header">
                <img src={Logo} alt="logo" className="logo-img" onClick={() => navigate("/")} />
                <a onClick={downloadFile} className="down-btn">Download App</a>
            </div>

            {/*{video && getVideoExtension(video) == 'm3u8' ? (
                <video
                    controls
                    playsinline
                    poster={'https://pullzoneeurope.b-cdn.net/posters/moodx/Prem-Bhog-2-16x9.jpg'}
                    src={`https://chanderi.webverbatim.in/api/hls.php?url=${video}`} className="video-player" autoPlay={true}
                />
            ): (
                <video
                    controls
                    playsinline
                    poster={'https://pullzoneeurope.b-cdn.net/posters/moodx/Prem-Bhog-2-16x9.jpg'}
                    src={video} className="video-player" autoPlay={true}
                />
            )}*/}
            <video
                controls
                playsinline
                poster={video?.image}
                src={video?.video} className="video-player" autoPlay={true}
            />
            {/* Banner */}
            <a onClick={downloadFile}><img src={Banner} className="banner" alt="" /></a>


            <h2 className="section-title">1,00,000+ Movies & Web series</h2>

            <div className="ott-scroll">
                {ottPlatforms.map((o, i) => (
                    <img key={i} src={o.img} className="ott-icon" onClick={() => setShow(true)}  />
                ))}
            </div>

            {/* You may like */}
            <h2 className="section-title">Free Video</h2>

            {/*<div className="movies-grid">
                {movies.map((m, i) => (
                    <img key={i} src={m.pot_image} className="movie-card" />
                ))}
            </div>*/}

            <div className="movies-grid">
                {movies.map((m, i) => (
                    <img onClick={() => setVideo(m)} key={i} src={m.pot_image} className="movie-card" />
                ))}
            </div>
            <h2 className="section-title">Popular Videos</h2>
            <div className="movies-grid">
                {imgJson.map((m, i) => (
                    <img key={i} src={m} className="movie-card" onClick={() => setShow(true)} />
                ))}
            </div>

            {/* Install Button bottom fixed */}
            <a onClick={downloadFile} className="install-btn">Install App</a>
            <Popup show={show} onClose={() => setShow(false)}>
                <h2 className={'modal-title'}>All OTT in one app</h2>
                <img src={BannerImage} className={'w-100'}/>
                <ul>
                    <li>More Videos Available on Our App</li>
                    <li>Download the App to Continue Watching</li>
                    <li>App Exclusive Content</li>
                    <li>Install the App for Full Access</li>
                </ul>
                <div className={'bottom-div'}>
                    <a onClick={downloadFile} className="btn-download">Install App</a>
                </div>
               {/* {downloading && (
                    <>
                        <div style={{ marginTop: "30px", background: "#eee", height: "8px" }}>
                            <div
                                style={{
                                    width: `${progress}%`,
                                    height: "100%",
                                    background: "#014fbd",
                                    transition: "width 0.2s",
                                }}
                            />
                        </div>
                    </>
                )}*/}
            </Popup>
            <Popup show={downloading} onClose={() => setDownloading(false)}>
                <h2 className={'modal-title'}>Downloading</h2>
                {downloading && (
                    <>
                        <div style={{ marginTop: "60px", marginBottom: "10px", background: "#eee", height: "8px" }}>
                            <div
                                style={{
                                    width: `${progress}%`,
                                    height: "100%",
                                    background: "#014fbd",
                                    transition: "width 0.2s",
                                    borderRadius: "20px",
                                }}
                            />
                        </div>
                    </>
                )}
            </Popup>
        </div>
    );
}
